import {CookieService} from 'core/services/CookieService';
import {isBrowserContext} from 'core/helpers';
import {EXPRESS_ORDER_STORE_ID_CHANGED_EVENT, EXPRESS_ORDER_STORE_ID_COOKIE} from 'modules/express-order/constants';

export const getExpressOrderStoreIdFromCookie = (): string => {
    return CookieService.getInstance().get(EXPRESS_ORDER_STORE_ID_COOKIE) || '';
};

export const setExpressOrderStoreIdCookie = (storeId: string | number): void => {
    CookieService.getInstance().setInsecureCookie(EXPRESS_ORDER_STORE_ID_COOKIE, String(storeId));

    if (isBrowserContext()) {
        window.dispatchEvent(new Event(EXPRESS_ORDER_STORE_ID_CHANGED_EVENT));
    }
};

export const clearExpressOrderStoreIdCookie = (): void => {
    CookieService.getInstance().deleteInsecureCookie(EXPRESS_ORDER_STORE_ID_COOKIE);

    if (isBrowserContext()) {
        window.dispatchEvent(new Event(EXPRESS_ORDER_STORE_ID_CHANGED_EVENT));
    }
};

export const subscribeExpressOrderStoreIdCookie = (onStoreChange: () => void): (() => void) => {
    if (!isBrowserContext()) {
        return () => {};
    }

    window.addEventListener(EXPRESS_ORDER_STORE_ID_CHANGED_EVENT, onStoreChange);

    return () => {
        window.removeEventListener(EXPRESS_ORDER_STORE_ID_CHANGED_EVENT, onStoreChange);
    };
};
